const styles = {
  container: {
    width: "375px",
    "@media screen and (max-width : 475px)": {
      width: "100vw",
    },
    margin: "0 auto",
    position: "fixed",
    left: 0,
    top: 0,
    zIndex: 9999,
    backgroundColor: "#FFFFFF",
    boxShadow: "0 2px 4px 0 rgba(0,0,0,0.1)",
    height: "100vh",
  },

  mediaContainer: {},

  imgContainer: {
    position: "relative",
    width: "49.5%",
    height: "127px",
    display: "inline-block",
    marginRight: "0.5%",
  },

  image: {
    width: "100%",
    height: "100%",
    display: "inline-block",
    objectFit: "cover",
  },
  thumbnailIcon: {
    position: "absolute",
    bottom: "10%",
    right: "5%",
  },
  campusReelIcon: {
    width: "32px",
    height: "32px",
    float: "right",
    borderRadius: "16px",
    background: "rgba(190,10,255,0.70)",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-around",
  },

  closeContainer: {
    height: "56px",
    padding: "16px",
    boxSizing: "border-box",
    cursor: "pointer",
    position: "sticky",
    zIndex: 10001,
    top: 0,
    boxShadow: "0 2px 4px 0 rgba(0,0,0,0.1)",

    textAlign: "center",
  },
  closeContainerTitle: {
    height: "20px",
    color: "#051D39",
    fontFamily: ({ theme }) => theme.fontFamily,
    fontSize: "16px",
    fontWeight: 300,
    lineHeight: "20px",
  },
  scrollContainer: {
    overflowY: "scroll",
    height: "calc(100vh - 130px)",
  },
  mainImageContainer: {
    width: "100%",
    height: "266px",
    marginBottom: "19px",
  },
  scene: {
    margin: "24px",
  },
  sceneTop: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  title: {
    width: "273px",
    color: "#051D39",
    fontFamily: "CircularStd",
    fontSize: "28px",
    fontWeight: 500,
    lineHeight: "36px",
    marginBottom: "10px",
  },
  description: {
    height: "auto",
    marginBottom: "24px",
    width: "327px",
    color: "#6373A4",
    fontFamily: "CircularStd",
    fontSize: "16px",
    fontWeight: 300,
    lineHeight: "24px",
  },
  iframe: {
    pointerEvents: "none",
  },
};

export default styles;
